import type { ExtensionConfig } from '@goto/shell'

import { getOOSArtifactUrl } from '../helpers/experience-helpers'

import { getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations } from '../models/feature-flag.models'

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-meeting-app',
  get url() {
    const version = getLaunchDarklyFlag(LaunchDarklyVariations.OOS_MEETING_APP_VERSION)
    return new URL(getOOSArtifactUrl('meeting-extension', version))
  },
}

export default extensionConfig
